/* eslint-disable max-len */
import React from 'react'
import DashBoardLineIcon from 'remixicon-react/DashboardLineIcon'
import DashBoardFillIcon from 'remixicon-react/DashboardFillIcon'
import FundsLineIcon from 'remixicon-react/FundsLineIcon'
import FundsFillIcon from 'remixicon-react/FundsFillIcon'
import LeafLineIcon from 'remixicon-react/LeafLineIcon'
import LeafFillIcon from 'remixicon-react/LeafFillIcon'
import BankCardLineIcon from 'remixicon-react/BankCardLineIcon'
import BankCardFillIcon from 'remixicon-react/BankCardFillIcon'
import FileCopyLineIcon from 'remixicon-react/FileCopy2LineIcon'
import FileCopyFillIcon from 'remixicon-react/FileCopy2FillIcon'
import BuildingLineIcon from 'remixicon-react/BuildingLineIcon'
import BuildingFillIcon from 'remixicon-react/BuildingFillIcon'
import UserLineIcon from 'remixicon-react/UserLineIcon'
import UserFillIcon from 'remixicon-react/UserFillIcon'
import TeamLineIcon from 'remixicon-react/TeamLineIcon'
import TeamFillIcon from 'remixicon-react/TeamFillIcon'
import PriceTagLineIcon from 'remixicon-react/PriceTag2LineIcon'
import PriceTagFillIcon from 'remixicon-react/PriceTag2FillIcon'
import GlobeLineIcon from 'remixicon-react/GlobeLineIcon'
import GlobeFillIcon from 'remixicon-react/GlobeFillIcon'
import GroupLineIcon from 'remixicon-react/GroupLineIcon'
import GroupFillIcon from 'remixicon-react/GroupFillIcon'
import ParentLineIcon from 'remixicon-react/ParentLineIcon'
import ParentFillIcon from 'remixicon-react/ParentFillIcon'
import FileList3LineIcon from 'remixicon-react/FileList3LineIcon'
import FileList3FillIcon from 'remixicon-react/FileList3FillIcon'
import SurveyLineIcon from 'remixicon-react/SurveyLineIcon'
import SurveyFillIcon from 'remixicon-react/SurveyFillIcon'
import { CoinLeaf, CoinLeafFill, FileLeaf, FileLeafFill } from '../icons'

export const userItems = [
  {
    groupLabel: 'menuItems.inicio',
    items: [
      {
        label: 'menuItems.visaoGeral',
        to: '/dashboard',
        icon: <DashBoardLineIcon />,
        activeIcon: <DashBoardFillIcon />,
      },
    ],
  },
  {
    groupLabel: 'menuItems.avaliacao',
    items: [
      {
        label: 'menuItems.pressaoBiodiversidade',
        to: '/pressaoBiodiversidade',
        icon: <FundsLineIcon />,
        activeIcon: <FundsFillIcon />,
      },
      {
        label: 'menuItems.desempenhoBiodiversidade',
        icon: <LeafLineIcon />,
        activeIcon: <LeafFillIcon />,
        subMenus: [
          {
            label: 'menuItems.desempenho',
            to: '/desempenhoBiodiversidade',
            icon: <FileLeaf />,
            activeIcon: <FileLeafFill />,
          },
          {
            label: 'menuItems.creditosBiodiversidade',
            to: '/desempenhoBiodiversidade/creditos-biodiversidade',
            icon: <CoinLeaf />,
            activeIcon: <CoinLeafFill />,
          },
        ],
      },
      {
        label: 'menuItems.indicadoresGestao',
        to: '/indicadoresGestao',
        icon: <BankCardLineIcon />,
        activeIcon: <BankCardFillIcon />,
      },
    ],
  },
  {
    groupLabel: 'menuItems.relatorios',
    items: [
      {
        label: 'menuItems.relatorios',
        to: '/relatorios',
        icon: <FileCopyLineIcon />,
        activeIcon: <FileCopyFillIcon />,
      },
    ],
  },
  {
    groupLabel: 'menuItems.auditoria',
    items: [
      {
        label: 'menuItems.planoAuditoria',
        to: '/secaoAuditoria',
        icon: <FileList3LineIcon />,
        activeIcon: <FileList3FillIcon />,
      },
      {
        label: 'menuItems.parecerAuditoria',
        to: '/parecerAuditoria',
        icon: <SurveyLineIcon />,
        activeIcon: <SurveyFillIcon />,
      },
    ],
  },
  {
    groupLabel: 'menuItems.configuracoes',
    items: [
      {
        label: 'menuItems.minhaEmpresa',
        to: '/dadosEmpresa',
        icon: <BuildingLineIcon />,
        activeIcon: <BuildingFillIcon />,
      },
      {
        label: 'menuItems.meuPerfil',
        to: '/meuPerfil',
        icon: <UserLineIcon />,
        activeIcon: <UserFillIcon />,
      },
    ],
  },
]

export const adminItems = [
  {
    groupLabel: 'menuItemsAdm.contas',
    items: [
      {
        label: 'menuItemsAdm.empresas',
        to: '/adm/empresas',
        icon: <BuildingLineIcon />,
        activeIcon: <BuildingFillIcon />,
      },
      {
        label: 'menuItemsAdm.usuarios',
        to: '/adm/usuarios',
        icon: <TeamLineIcon />,
        activeIcon: <TeamFillIcon />,
      },
      {
        label: 'menuItemsAdm.licencas',
        to: '/adm/licencas',
        icon: <PriceTagLineIcon />,
        activeIcon: <PriceTagFillIcon />,
      },
    ],
  },
  {
    groupLabel: 'menuItemsAdm.auditoria',
    items: [
      {
        label: 'menuItemsAdm.auditores',
        to: '/adm/auditores',
        icon: <ParentLineIcon />,
        activeIcon: <ParentFillIcon />,
      },
    ],
  },
  {
    groupLabel: 'menuItemsAdm.configuracoes',
    items: [
      {
        label: 'menuItemsAdm.paisesCalculos',
        to: '/adm/paisesCalculos',
        icon: <GlobeLineIcon />,
        activeIcon: <GlobeFillIcon />,
      },
      {
        label: 'menuItemsAdm.usuariosLife',
        to: '/adm/usuariosLife',
        icon: <GroupLineIcon />,
        activeIcon: <GroupFillIcon />,
      },
    ],
  },
]

export const auditorItems = [
  {
    groupLabel: 'menuItems.inicio',
    items: [
      {
        label: 'menuItems.auditorias',
        to: '/auditorias',
        icon: <ParentLineIcon />,
        activeIcon: <ParentFillIcon />,
      },
    ],
  },
  {
    groupLabel: 'menuItems.configuracoes',
    items: [
      {
        label: 'menuItems.meuPerfil',
        to: '/auditoria/meuPerfil',
        icon: <UserLineIcon />,
        activeIcon: <UserFillIcon />,
      },
    ],
  },
]
